import { render } from "./MyAddresses.vue?vue&type=template&id=8a449eca"
import script from "./MyAddresses.vue?vue&type=script&lang=js"
export * from "./MyAddresses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__